import { render, staticRenderFns } from "./GroupProccess.vue?vue&type=template&id=382eec39&"
import script from "./GroupProccess.vue?vue&type=script&lang=js&"
export * from "./GroupProccess.vue?vue&type=script&lang=js&"
import style0 from "./GroupProccess.vue?vue&type=style&index=0&id=382eec39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports